import { call, put, takeLatest } from "redux-saga/effects";
import * as actionTypes from "../ActionTypes";

import {
  saveChurchCoverImageSuccess,
  saveChurchCoverImageFailure,
  updateChurchCoverImageSuccess,
  updateChurchCoverImageFailure,
  deleteChurchCoverImageSuccess,
  deleteChurchCoverImageFailure,
} from "./churchCoverImageActions";

import {
  saveChurchCoverImageApi,
  updateChurchCoverImageApi,
  deleteChurchCoverImageApi
} from "./churchCoverImage";

// 🔹 SAVE CHURCH COVER IMAGE
function* saveChurchCoverImageSaga(action) {
    try {
      const { apiPayloadRequest, callback } = action.payload || {};
      // ✅ apiPayloadRequest should now contain "_id", not "coverimageObjId"
      const data = yield call(saveChurchCoverImageApi, apiPayloadRequest);
  
      if (data?.type === 1) {
        yield put(saveChurchCoverImageSuccess(data.data || apiPayloadRequest));
        if (callback) callback({ type: 1, data: data.data });
      } else {
        yield put(saveChurchCoverImageFailure(data?.error || "Save failed"));
        if (callback) callback({ type: 0, error: data?.error });
      }
    } catch (error) {
      yield put(saveChurchCoverImageFailure(error.message));
      if (action.payload?.callback)
        action.payload.callback({ type: 0, error: error.message });
    }
  }
  

// 🔹 UPDATE CHURCH COVER IMAGE
function* updateChurchCoverImageSaga(action) {
  try {
    const { apiPayloadRequest, callback } = action.payload;
    const data = yield call(updateChurchCoverImageApi, apiPayloadRequest);

    if (data?.type === 1) {
      yield put(updateChurchCoverImageSuccess(data?.data || apiPayloadRequest));
      if (callback) callback({ type: 1, data: data?.data });
    } else {
      yield put(updateChurchCoverImageFailure(data?.error || "Update failed"));
      if (callback) callback({ type: 0, error: data?.error });
    }
  } catch (error) {
    yield put(updateChurchCoverImageFailure(error.message));
    if (action.payload?.callback)
      action.payload.callback({ type: 0, error: error.message });
  }
}
function* deleteChurchCoverImageSaga(action) {
    try {
      const { apiPayloadRequest, callback } = action.payload;
      const data = yield call(deleteChurchCoverImageApi, apiPayloadRequest);
  
      if (data?.type === 1) {
        yield put(deleteChurchCoverImageSuccess(apiPayloadRequest));
        if (callback) callback({ type: 1 });
      } else {
        yield put(deleteChurchCoverImageFailure(data?.error || "Delete failed"));
        if (callback) callback({ type: 0, error: data?.error });
      }
    } catch (error) {
      yield put(deleteChurchCoverImageFailure(error.message));
      if (action.payload?.callback)
        action.payload.callback({ type: 0, error: error.message });
    }
  }
// 🔹 WATCHER
export default function* churchCoverImageWatcherSaga() {
  yield takeLatest(actionTypes.SAVE_CHURCH_COVERIMAGE_REQUEST, saveChurchCoverImageSaga);
  yield takeLatest(actionTypes.UPDATE_CHURCH_COVERIMAGE_REQUEST, updateChurchCoverImageSaga);
  yield takeLatest(actionTypes.DELETE_CHURCH_COVERIMAGE_REQUEST, deleteChurchCoverImageSaga);

}
